import React, { Children, cloneElement } from 'react';

// LOCAL COMPONENTS
import NoResults from 'core/tools/NoResults';

function NoChartResults({ children, isLoading, ...props }) {
  const icon = {
    use: isLoading ? 'clock' : 'chart'
  };

  return props.data?.length ? (
    Children.map(children, (child, i) =>
      child
        ? cloneElement(child, {
            ...props,
            key: i
          })
        : null
    )
  ) : (
    <NoResults icon={icon}>
      <small className="text-primary-extra-light">{isLoading ? 'Loading...' : 'No Results Found'}</small>
    </NoResults>
  );
}

export default function withNoResults(Component) {
  const WrappedComponent = props => {
    return (
      <NoChartResults {...props}>
        <Component />
      </NoChartResults>
    );
  };

  return WrappedComponent;
}
